import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSButton } from '../button/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
var EGDSPagingButtonTheme;
(function (EGDSPagingButtonTheme) {
  EGDSPagingButtonTheme["SOLID"] = "solid-btn";
  EGDSPagingButtonTheme["TRANSPARENT"] = "transparent-btn";
})(EGDSPagingButtonTheme || (EGDSPagingButtonTheme = {}));
class EGDSPagingButton extends React.Component {
  static displayName = 'EGDSPagingButton';
  render() {
    const {
      icon,
      iconId,
      iconTitle,
      pagingOverlay,
      children,
      ...props
    } = this.props;
    const cssClassNames = classNames(props.className, `${EGDSButton.baseClassName}-paging`, {
      [`${EGDSButton.baseClassName}-paging-overlay`]: pagingOverlay || props.theme === EGDSPagingButtonTheme.TRANSPARENT
    });
    return jsxs(EGDSButton, {
      ...props,
      className: cssClassNames,
      children: [icon && jsx(EGDSIcon, {
        name: icon,
        id: iconId,
        title: iconTitle
      }), children || null]
    });
  }
}
export { EGDSPagingButton, EGDSPagingButtonTheme };